import { request } from '@/request'

//根据应用类型分组获取最新的应用包
export const selectLatestAppGrouping = (params:any) => request({
    url: '/common/selectLatestAppGrouping',
    params,
    isLoading: false,
    needToken: false
})
//获取信令服务websocket地址
export const signalWsUri = () => request({
    url: '/sm/realTimeBroadcast/turnUrl',
    isLoading: false,
    needToken: false
})
//保存ip
export const accessAdd = () => request({
    url: '/access/add',
	method: 'POST',
	headers: {
	    'Content-Type': 'application/json'
	},
    isLoading: false,
    needToken: false
})